import { Box, Button, Chip, Container, Paper, Stack, Typography } from '@mui/material'
import video from "../../assets/video/coffee.mp4"

export default function Hero() {
  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      
      {/* 🎥 Видео фон */}
      <Box
        component="video"
        autoPlay
        loop
        muted
        playsInline
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      >
        <source src={video} type="video/mp4" />
      </Box>

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.9))',
          zIndex: 1,
        }}
      />

      {/* 📦 контент */}
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 2,
          py: { xs: 10, md: 14 },
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1.4fr 1fr' },
            gap: 5,
            alignItems: 'center',
          }}
        >
          <Box>
            <Chip
              label="Free installation for qualified locations"
              sx={{
                mb: 3,
                color: '#fff',
                backgroundColor: 'rgba(255,255,255,0.06)',
              }}
            />

            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 3,
                fontSize: { xs: '2.5rem', md: '4.5rem' },
              }}
            >
              Add a modern vending experience to your location
            </Typography>

            <Typography sx={{ color: 'rgba(255,255,255,0.8)' }}>
              Coffee machines, protein shakes and food kiosks with zero upfront cost.
            </Typography>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4 }}>
              <Button variant="contained">Get Free Placement</Button>
              <Button variant="outlined" color="inherit">Learn More</Button>
            </Stack>
          </Box>

          <Paper sx={{ p: 4, background: 'rgba(96, 96, 96, 0.5)', color: '#fff' }}>
            Turn customer wait time into revenue
          </Paper>
        </Box>
      </Container>
    </Box>
  )
}